var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns",staticStyle:{"margin-top":"-0.2rem"}},[_c('div',{staticClass:"column has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.moment
        .utc(_vm.statusHistory.deliveryCreatedAt)
        .add(_vm.preferences.timezone, "h")
        .format("DD/MM/YY HH:mm:ss"))+"\n  ")]),_c('div',{staticClass:"column has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.statusHistory.accessedByCourierAt
        ? _vm.moment
            .utc(_vm.statusHistory.accessedByCourierAt)
            .add(_vm.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : _vm.statusHistory.deliveryConfirmedAt
        ? _vm.moment
            .utc(_vm.statusHistory.deliveryConfirmedAt)
            .add(_vm.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : _vm.statusHistory.waitingPickUpAt
        ? _vm.moment
            .utc(_vm.statusHistory.waitingPickUpAt)
            .add(_vm.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : "-")+"\n  ")]),_c('div',{staticClass:"column has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.statusHistory.accessedByClientAt
        ? _vm.moment
            .utc(_vm.statusHistory.accessedByClientAt)
            .add(_vm.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : _vm.statusHistory.pickUpConfirmedAt
        ? _vm.moment
            .utc(_vm.statusHistory.pickUpConfirmedAt)
            .add(_vm.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : "-")+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }